// Alla globala tjänste-, konverterings- och materialsidor.
// Varje sida har unik title, meta description, H1 och route-specifikt innehåll.
import { IMAGES } from "./company.js";

const ALL_SERVICES = [
  {
    slug: "taklaggare",
    path: "/taklaggare/",
    title: "Takläggning & takrenovering – begär offert | TISAB",
    metaDescription: "Lägga nytt tak eller renovera det befintliga? TISAB hjälper villa, BRF och företag med material, underarbete och plåt. Få offert i Stockholm och Mälardalen.",
    h1: "Takläggning för villa, BRF och företag",
    intro: "TISAB är takläggare för villa, BRF och företag i Stockholm och Mälardalen. Vi tar hand om hela taket – från första kontroll till färdigt ytskikt – med egen plåtverkstad och erkända svenska material.",
    who: "Privatkunder med villa och radhus, BRF, företag och fastighetsägare som behöver en takläggare för nytt tak, omläggning eller renovering.",
    commonProblems: [
      "Takets ytskikt börjar nå sin tekniska livslängd",
      "Synliga skador eller läckage efter regn",
      "Oklart om taket kan repareras, renoveras eller bytas",
      "Behov av samordnad takläggning med plåtdetaljer",
    ],
    whatWeDo: [
      "Behovsbedömning och projektering",
      "Ställning, logistik och demontering",
      "Råspont, underlagspapp, läkt och ytskikt",
      "Plåtdetaljer från egen plåtverkstad",
      "Taksäkerhet och slutkontroll",
    ],
    includes: [
      "Behovsbedömning",
      "Projektering",
      "Ställning och logistik",
      "Demontering",
      "Råspont",
      "Underlagspapp",
      "Läkt",
      "Ytskikt",
      "Plåtdetaljer",
      "Taksäkerhet",
      "Slutkontroll",
    ],
    process: ["Kontakt & behovsbedömning", "Platsbesök & projektering", "Offert", "Genomförande", "Slutkontroll"],
    priceFactors: ["Takyta", "Takets form och lutning", "Nuvarande och nytt material", "Underarbete och ställning", "Plåtdetaljer och genomföringar", "Åtkomst och logistik"],
    relatedMaterials: ["plattak", "papptak", "tegeltak", "takmaterial/betongpannor"],
    relatedServices: ["byta-tak", "platslageri", "takbesiktning"],
    relatedGuides: ["nar-ar-det-dags-att-byta-tak", "valja-takmaterial", "tecken-pa-takskador"],
    faq: [
      { q: "Hur vet jag om jag behöver en takläggare?", a: "Om taket har synliga skador, läcker, eller ytskiktet närmar sig sin tekniska livslängd är det läge att kontakta en takläggare för en bedömning. Vi hjälper dig avgöra om taket kan repareras, renoveras eller bytas." },
      { q: "Vilka material arbetar TISAB med?", a: "Vi arbetar nästan uteslutande med erkända svenska märken och lägger bland annat plåt, papp, lertegel och betongpannor." },
      { q: "Har ni egen plåtverkstad?", a: "Ja, TISAB har en egen plåtverkstad där vi tillverkar måttanpassade takplåtar, beslag och detaljer." },
    ],
    image: IMAGES.hero,
    schemaType: "RoofingContractor",
  },
  {
    slug: "takrenovering",
    path: "/takrenovering/",
    title: "Takrenovering i Stockholm | Renovera Tak – TISAB",
    metaDescription: "Takrenovering i Stockholm för villa, BRF och företag. TISAB renoverar plåttak, papptak och tegeltak med egen plåtverkstad. Begär kostnadsfri offert.",
    h1: "Takrenovering i Stockholm",
    intro: "Takrenovering innebär att vi byter ut slitna delar av taket och förnyar ytskiktet så att taket får en lång livslängd. TISAB renoverar plåttak, papptak och tegeltak för privatkunder, BRF och företag i hela Stockholms län.",
    who: "Fastighetsägare där takets ytskikt är slitet men takstolar och underlag är i gott skick – och där ett komplett byte ännu inte är nödvändigt.",
    commonProblems: [
      "Slitet ytskikt men intakta takstolar",
      "Läckage vid specifika punkter",
      "Rost eller flagnande färg på plåttak",
      "Skadade eller lösa pannor",
    ],
    whatWeDo: [
      "Bedömning av vad som kan renoveras",
      "Riktad omläggning av ytskikt",
      "Byte av underlagspapp och läkt",
      "Plåtdetaljer och anslutningar",
      "Målning där det är lämpligt",
    ],
    includes: ["Behovsbedömning", "Demontering av slitna delar", "Råspont och underlag", "Nytt ytskikt", "Plåtdetaljer", "Taksäkerhet", "Slutkontroll"],
    process: ["Kontakt & bedömning", "Platsbesök", "Offert", "Renovering", "Slutkontroll"],
    priceFactors: ["Omfattning av renovering", "Materialval", "Underarbete", "Plåtdetaljer", "Åtkomst"],
    relatedMaterials: ["plattak", "papptak", "tegeltak"],
    relatedServices: ["taklaggare", "byta-tak", "takservice", "takmalning"],
    relatedGuides: ["nar-ar-det-dags-att-byta-tak", "tecken-pa-takskador", "underhall-av-tak-aret-runt"],
    faq: [
      { q: "Vad är skillnaden mellan takrenovering och takbyte?", a: "Begreppen kan användas på olika sätt. Be därför om en offert som beskriver exakt vilka lager och delar som bevaras, repareras eller byts. Ett takbyte innebär inte automatiskt att takstolarna behöver ersättas." },
      { q: "Kan mitt tak renoveras i stället för bytas?", a: "Det beror på takets skick. En besiktning eller bedömning visar om underlaget är intakt och renovering är möjlig." },
    ],
    image: IMAGES.metalDetail,
    schemaType: "Service",
  },
  {
    slug: "byta-tak",
    path: "/byta-tak/",
    title: "Byta tak – takbyte med egen plåtverkstad | TISAB",
    metaDescription: "Ska du byta tak? TISAB har arbetat med tak sedan 2009, har egen plåtverkstad och tar ansvar hela vägen. Begär kostnadsfri offert på ditt takbyte.",
    h1: "Byta tak i Stockholm",
    intro: "Ska du byta tak? TISAB har arbetat med tak sedan 2009, har en egen plåtverkstad och tar ansvar för takbytet hela vägen – från materialval och underarbete till plåtdetaljer och slutkontroll. Vi hjälper privatkunder, BRF och företag i Stockholm och Mälardalen.",
    shortAnswer: "Vid ett takbyte ersätts takets ytskikt och de underliggande delar som behöver åtgärdas. Takstolar och andra bärande delar bedöms separat, och den överenskomna omfattningen framgår av offerten.",
    who: "Fastighetsägare där taket nått sin tekniska livslängd, har omfattande skador eller där underlaget inte längre håller för en renovering.",
    commonProblems: [
      "Takets underlag och ytskikt är uttjänat",
      "Upprepade läckage och skador",
      "Takets konstruktion behöver förnyas",
      "Önskemål om nytt material vid byte",
    ],
    whatWeDo: [
      "Komplett eller avgränsat takbyte",
      "Materialrådgivning",
      "Underarbete och råspont",
      "Takavvattning och genomföringar",
      "Plåtdetaljer från egen verkstad",
      "Slutkontroll",
    ],
    includes: ["Komplett eller avgränsat takbyte", "Materialrådgivning", "Underarbete", "Takavvattning", "Genomföringar", "Plåtdetaljer", "Slutkontroll"],
    process: ["Kontakt & behov", "Platsbesök & projektering", "Offert", "Takbyte", "Slutkontroll"],
    priceFactors: ["Takyta", "Takets form och lutning", "Nuvarande och nytt material", "Underarbete, råspont och ställning", "Genomföringar, kupor och skorstenar", "Plåtdetaljer och avvattning", "Åtkomst och eventuell skada"],
    relatedMaterials: ["plattak", "papptak", "tegeltak", "takmaterial/betongpannor"],
    relatedServices: ["taklaggare", "pris-pa-tak", "delbetalning", "takbesiktning"],
    relatedGuides: ["vad-kostar-ett-takbyte", "valja-takmaterial", "nar-ar-det-dags-att-byta-tak"],
    faq: [
      { q: "Hur går det till när man ska byta tak?", a: "Du kontaktar TISAB och beskriver taket. Därefter görs en behovsbedömning och ett platsbesök med projektering, och du får en offert som anger omfattningen. När du har tackat ja genomförs takbytet, och arbetet avslutas med en slutkontroll." },
      { q: "Hur lång tid tar det att byta tak?", a: "Det varierar med takets storlek och omfattning. Ett mindre villatak kan oftast genomföras under några dagar till en vecka, medan större projekt tar längre tid. Tidsplanen anges när omfattningen är bedömd." },
      { q: "Hur begär jag offert på att byta tak?", a: "Fyll i kontaktformuläret eller ring TISAB. Beskriv takets material och form, var fastigheten ligger och vad du vill åtgärda. Bilder hjälper bedömningen. Offerten är kostnadsfri." },
      { q: "Vad kostar det att byta tak?", a: "Priset beror på takyta, form, lutning, material, underarbete och åtkomst. Vi ger en offert utifrån ditt taks förutsättningar. Läs mer under pris på tak." },
      { q: "Kan jag få ROT-avdrag?", a: "Du kan ha rätt till ROT-avdrag för en del av arbetskostnaden. Material och resor ger inte rätt till avdrag. Ditt skatteutrymme och aktuella regler påverkar avdraget. Kontrollera aktuella regler hos Skatteverket." },
    ],
    image: IMAGES.villaMetal,
    schemaType: "Service",
  },
  {
    slug: "takbesiktning",
    path: "/takbesiktning/",
    title: "Takbesiktning i Stockholm – bedöm takets skick | TISAB",
    metaDescription: "Osäker på takets skick? TISAB kontrollerar kritiska punkter och ger förslag på åtgärder. Boka takbesiktning inför underhåll, takbyte eller solceller.",
    h1: "Takbesiktning inför beslut om taket",
    intro: "En takbesiktning ger dig ett tydligt underlag för att veta om taket kan repareras, renoveras eller bytas. TISAB kontrollerar kritiska punkter, synliga skador och läckagerisker och ger konkreta åtgärdsförslag.",
    who: "Kunder som inte vet om taket behöver repareras, renoveras eller bytas – och som behöver ett underlag innan beslut.",
    commonProblems: [
      "Oklart takskick inför beslut",
      "Misstänkta skador utan synligt läckage",
      "Underlag inför försäljning eller upphandling",
      "Bedömning inför solcellsinstallation",
    ],
    whatWeDo: [
      "Kontroll av kritiska punkter",
      "Synliga skador och läckagerisker",
      "Material, plåt, pannor och papp",
      "Avvattning och taksäkerhet",
      "Rekommendationer och åtgärdsförslag",
    ],
    includes: ["Kontroll av kritiska punkter", "Synliga skador", "Läckagerisker", "Material och plåt", "Pannor och papp", "Avvattning", "Taksäkerhet", "Åtgärdsförslag"],
    process: ["Bokning", "Besiktning", "Rapport med åtgärdsförslag", "Eventuell offert"],
    priceFactors: ["Takets storlek och typ", "Åtkomst", "Omfattning av besiktning"],
    relatedMaterials: [],
    relatedServices: ["takservice", "byta-tak", "serviceavtal"],
    relatedGuides: ["tecken-pa-takskador", "takbesiktning-infor-solceller", "underhall-av-tak-aret-runt"],
    faq: [
      { q: "Vad kostar en takbesiktning?", a: "Pris, omfattning och dokumentation beror på vad som ska undersökas. Kontakta oss så går vi igenom villkoren innan du bokar en fristående takbesiktning." },
      { q: "När behövs en takbesiktning?", a: "När du är osäker på takets skick, inför ett större beslut, eller innan en solcellsinstallation för att bedöma om taket behöver åtgärdas först." },
      { q: "Är takbesiktningen oberoende av takentreprenören?", a: "TISAB är takentreprenör och kan även lämna offert på åtgärder. Om du behöver en oberoende status- eller entreprenadbesiktning bör du anlita en besiktningsman med ett separat uppdrag. Stäm av syfte, omfattning och dokumentation före bokning." },
    ],
    image: IMAGES.brfAerial,
    schemaType: "Service",
  },
  {
    slug: "takservice",
    path: "/takservice/",
    title: "Takservice i Stockholm – laga & underhåll taket | TISAB",
    metaDescription: "Läckage, skadade pannor eller problem med avvattning? TISAB hjälper med felsökning och takunderhåll i Stockholm. Beskriv problemet och få en bedömning.",
    h1: "Takservice och takunderhåll i Stockholm",
    intro: "Takservice handlar om att förebygga skador och hålla taket i gott skick över tid. TISAB utför felsökning av läckage, tätning, mindre reparationer och kontroll av avvattning och taksäkerhet – med dokumenterad uppföljning enligt avtal.",
    who: "Privatkunder, BRF, företag och fastighetsägare som vill förebygga skador och säkerställa att taket fungerar över tid.",
    commonProblems: [
      "Återkommande småläckage",
      "Stoppade stuprör och hängrännor",
      "Lösa pannor eller detaljer",
      "Behov av förebyggande underhåll",
    ],
    whatWeDo: [
      "Felsökning av läckage",
      "Tätning och mindre reparationer",
      "Byte av skadade pannor",
      "Kontroll av stuprör och hängrännor",
      "Taksäkerhet och löv- och skräpröjning",
      "Dokumenterad uppföljning enligt avtal",
    ],
    includes: ["Felsökning av läckage", "Tätning", "Mindre reparationer", "Pannbyten", "Kontroll av stuprör och hängrännor", "Taksäkerhet", "Löv och skräp", "Förebyggande underhåll", "Dokumenterad uppföljning"],
    process: ["Kontakt", "Bedömning", "Åtgärd", "Dokumenterad uppföljning"],
    priceFactors: ["Omfattning", "Åtkomst", "Material", "Avtalsupplägg"],
    relatedMaterials: [],
    relatedServices: ["serviceavtal", "takbesiktning", "snoskottning"],
    relatedGuides: ["underhall-av-tak-aret-runt", "tecken-pa-takskador"],
    faq: [
      { q: "Vad ingår i takservice?", a: "Felsökning, tätning, mindre reparationer, pannbyten, kontroll av avvattning, taksäkerhet och förebyggande underhåll – med dokumenterad uppföljning enligt avtal." },
      { q: "Kan jag teckna serviceavtal?", a: "Ja, vi erbjuder serviceavtalen Trygghet Tak – Komplett, Underhåll och Snö & is. Se vår sida om serviceavtal." },
    ],
    image: IMAGES.rooferWork,
    schemaType: "Service",
  },
  {
    slug: "takreparation",
    path: "/takreparation/",
    title: "Takreparation & Läckagelagning i Stockholm – TISAB",
    metaDescription: "Takreparation i Stockholm. TISAB åtgärdar läckage, tätar, byter skadade pannor och reparerar plåtdetaljer. Snabb felsökning för villa, BRF och företag.",
    h1: "Takreparation i Stockholm",
    intro: "Takreparation är rätt val när taket har en avgränsad skada som kan åtgärdas utan renovering eller byte. TISAB felsöker läckage, tätar, byter skadade pannor och reparerar plåtdetaljer för privatkunder, BRF och företag.",
    who: "Fastighetsägare med avgränsade skador, läckage eller skadade detaljer där ett ingripande räcker – utan att hela taket behöver renoveras.",
    commonProblems: [
      "Plötsligt läckage efter regn eller smältning",
      "Enstaka skadade eller spruckna pannor",
      "Läckage vid genomföringar eller plåtanslutningar",
      "Skador efter storm eller rinnvatten",
    ],
    whatWeDo: [
      "Felsökning av läckage",
      "Tätning av otätheter",
      "Byte av skadade pannor",
      "Reparation av plåtdetaljer",
      "Kontroll av avvattning",
    ],
    includes: ["Felsökning", "Tätning", "Pannbyten", "Plåtreparation", "Kontroll av avvattning", "Dokumentation"],
    process: ["Kontakt", "Felsökning", "Reparation", "Kontroll"],
    priceFactors: ["Skadans omfattning", "Åtkomst", "Material", "Akut eller planerat"],
    relatedMaterials: ["plattak", "papptak", "tegeltak"],
    relatedServices: ["takservice", "takbesiktning", "byta-tak", "platslageri"],
    relatedGuides: ["tecken-pa-takskador", "underhall-av-tak-aret-runt"],
    faq: [
      { q: "Vad är skillnaden mellan takreparation och takservice?", a: "Takreparation åtgärdar en specifik skada, medan takservice är löpande förebyggande underhåll. Båda kan ingå i ett serviceavtal." },
      { q: "Kan ni åtgärda akuta läckage?", a: "Vi felsöker och åtgärdar läckage. Kontakta oss så bedömer vi hur snabbt vi kan vara på plats." },
    ],
    image: IMAGES.metalDetail,
    schemaType: "Service",
  },
  {
    slug: "takmalning",
    path: "/takmalning/",
    title: "Takmålning i Stockholm – måla & vårda plåttak | TISAB",
    metaDescription: "Behöver plåttaket målas? TISAB bedömer underlaget och hjälper med rengöring, rostbehandling och målning. Läs om förarbetet och begär en offert.",
    h1: "Takmålning och underhåll av plåttak",
    intro: "Takmålning kan förlänga livslängden på ett plåttak med intakt material. TISAB kontrollerar takets skick, rost och befintligt färgskikt och målar med ett system anpassat till materialet. Ibland är målning rätt – ibland behöver taket i stället repareras eller bytas.",
    who: "Fastighetsägare med plåttak där ytan har rost eller flagnande färg men där materialet i övrigt är i gott skick.",
    commonProblems: [
      "Rost på plåttak",
      "Flagnande eller blekt färgskikt",
      "Oklart om målning räcker eller om taket behöver bytas",
    ],
    whatWeDo: [
      "Kontroll av takets skick",
      "Kontroll av rost och befintligt färgskikt",
      "Nödvändigt förarbete och rengöring",
      "Målning med system anpassat till materialet",
    ],
    includes: ["Kontroll av skick", "Kontroll av rost", "Kontroll av färgskikt", "Förarbete", "Rengöring", "Målning"],
    process: ["Kontakt & kontroll", "Bedömning", "Förarbete", "Målning", "Kontroll"],
    priceFactors: ["Takyta", "Material", "Rostomfattning", "Förarbete", "Åtkomst"],
    relatedMaterials: ["plattak"],
    relatedServices: ["takservice", "byta-tak"],
    relatedGuides: ["underhall-av-tak-aret-runt", "valja-takmaterial", "tecken-pa-takskador"],
    faq: [
      { q: "Kan alla plåttak målas?", a: "Det beror på materialets skick. Vi kontrollerar rost och färgskikt innan vi rekommenderar målning. Ibland behöver taket i stället repareras eller bytas." },
      { q: "Hur ofta ska ett plåttak målas?", a: "Det varierar med material, läge och skick. En kontroll visar när målning är aktuell." },
    ],
    image: IMAGES.metalDetail,
    schemaType: "Service",
  },
  {
    slug: "takmalning/plattak",
    path: "/takmalning/plattak/",
    title: "Måla Plåttak i Stockholm | Rostskydd & Takmålning – TISAB",
    metaDescription: "Måla plåttak i Stockholm. TISAB kontrollerar rost, flagnande färg och befintligt system – och målar med rostskydd anpassat till plåttak. Begär offert.",
    h1: "Måla plåttak i Stockholm",
    intro: "Att måla ett plåttak kräver rätt förarbete och ett färgsystem anpassat till materialet. TISAB kontrollerar rost, flagnande färg och det befintliga färgsystemet innan vi målar – och bedömer om målning är rätt eller om taket behöver åtgärdas på annat sätt.",
    who: "Fastighetsägare med plåttak som har rost eller flagnande färg där materialet i övrigt håller för en målning.",
    commonProblems: [
      "Rostiga ytor på plåttak",
      "Flagnande färg efter många år",
      "Blekt eller oxiderat färgskikt",
    ],
    whatWeDo: [
      "Kontroll av rost",
      "Bedömning av befintligt färgsystem",
      "Rengöring och förarbete",
      "Målning med rostskyddssystem",
      "Bedömning av om taket i stället behöver repareras eller bytas",
    ],
    includes: ["Kontroll av rost", "Kontroll av färgskikt", "Rengöring", "Förarbete", "Målning med rostskydd"],
    process: ["Kontakt", "Kontroll av rost och färg", "Förarbete", "Målning", "Slutkontroll"],
    priceFactors: ["Takyta", "Rostomfattning", "Förarbete", "Färgsystem", "Åtkomst"],
    relatedMaterials: ["plattak"],
    relatedServices: ["takmalning", "takservice", "byta-tak"],
    relatedGuides: ["underhall-av-tak-aret-runt", "valja-takmaterial"],
    faq: [
      { q: "När bör jag måla plåttaket i stället för att byta det?", a: "Om plåten är i gott skick men färgen är sliten eller rostig kan målning räcka. Om materialet är tunt eller skadat kan reparation eller byte vara nödvändigt – vi bedömer detta." },
      { q: "Kan jag måla plåttaket själv?", a: "Takmålning med rostskydd kräver rätt förarbete och säkerhetsutrustning. Vi rekommenderar inte farliga gör-det-själv-insatser på taket." },
    ],
    image: IMAGES.metalDetail,
    schemaType: "Service",
  },
  {
    slug: "platslageri",
    path: "/platslageri/",
    title: "Plåtslageri & plåtarbeten – egen verkstad | TISAB",
    metaDescription: "Behöver taket nya beslag, rännor eller måttanpassad plåt? TISAB tillverkar i egen plåtverkstad och utför plåtarbeten på tak. Beskriv ditt projekt.",
    h1: "Plåtslageri med egen plåtverkstad",
    intro: "TISAB har en egen plåtverkstad där vi tillverkar måttanpassade takplåtar, beslag, anslutningar och genomföringar. Att ha plåtslageriet i samma organisation som takläggningen minskar behovet av onödiga mellanhänder – och gör att detaljerna passar ditt tak.",
    who: "Privatkunder, BRF och företag som behöver måttanpassade plåtdetaljer som en del av ett takprojekt eller en reparation.",
    commonProblems: [
      "Behov av specialanpassade plåtdetaljer",
      "Plåtanslutningar som inte passar standardmått",
      "Önskemål om samordnad plåt och takläggning",
    ],
    whatWeDo: [
      "Måttanpassade takplåtar",
      "Beslag och anslutningar",
      "Genomföringar",
      "Plåtdetaljer för tak och avvattning",
    ],
    includes: ["Egen plåtverkstad", "Måttanpassade takplåtar", "Beslag", "Anslutningar", "Genomföringar", "Plåtdetaljer"],
    process: ["Måtttagning", "Tillverkning", "Montering", "Kontroll"],
    priceFactors: ["Antal detaljer", "Material", "Måttanpassning", "Montering"],
    relatedMaterials: ["plattak"],
    relatedServices: ["plattak", "taklaggare", "byta-tak", "takservice"],
    relatedGuides: ["valja-takmaterial"],
    faq: [
      { q: "Vad innebär en egen plåtverkstad?", a: "Vi tillverkar plåtdetaljerna själva i stället för att köpa in färdiga. Det gör att detaljerna kan anpassas efter ditt tak." },
      { q: "Sparar egen plåtverkstad tid och pengar?", a: "Egen plåtverkstad gör det möjligt att samordna tillverkning och montering inom samma organisation. Kostnad och tid beror på vilka detaljer ditt tak behöver." },
    ],
    image: IMAGES.metalDetail,
    schemaType: "Service",
  },
  {
    slug: "serviceavtal",
    path: "/serviceavtal/",
    title: "Serviceavtal för tak – jämför våra avtal | TISAB",
    metaDescription: "Planera takets underhåll med Trygghet Tak. Jämför TISAB:s serviceavtal för kontroll, underhåll samt snö och is. För BRF, företag och fastighetsägare.",
    h1: "Serviceavtal för tak",
    intro: "Ett serviceavtal ger dig löpande kontroll och förebyggande underhåll av taket. TISAB erbjuder Trygghet Tak – Komplett, Underhåll och Snö & is. Kontrollintervall och åtgärdernas omfattning bestäms i avtalet för din fastighet.",
    who: "BRF, företag och fastighetsägare som vill säkerställa långsiktigt takunderhåll – och privatkunder som vill ha återkommande kontroll.",
    commonProblems: [
      "Oklart vem som ansvarar för takunderhåll",
      "Behov av återkommande kontroll",
      "Risk för vinterskador utan bevakning",
    ],
    whatWeDo: ["Återkommande kontroller enligt avtal", "Genomgång av tak", "Kontroll av avvattning och taksäkerhet", "Mindre tätningar och pannbyten", "Akuta åtgärder enligt avtal", "Rapportering"],
    includes: ["Se avtalsjämförelse nedan"],
    process: ["Val av avtal", "Första kontroll", "Löpande bevakning", "Rapportering"],
    priceFactors: ["Avtalstyp", "Takets storlek", "Antal byggnader"],
    relatedMaterials: [],
    relatedServices: ["takservice", "snoskottning", "takbesiktning", "taklaggare"],
    relatedGuides: ["underhall-av-tak-aret-runt", "takrenovering-for-brf"],
    faq: [
      { q: "Vilka avtal erbjuder ni?", a: "Trygghet Tak – Komplett, Trygghet Tak – Underhåll och Trygghet Tak – Snö & is. Se jämförelsen nedan." },
      { q: "Vem passar ett serviceavtal?", a: "Främst BRF, företag och fastighetsägare, men även privatkunder som vill ha återkommande kontroll av sitt tak." },
    ],
    image: IMAGES.brfAerial,
    schemaType: "Service",
  },
  {
    slug: "snoskottning",
    path: "/snoskottning/",
    title: "Takskottning & istappsborttagning i Stockholm | TISAB",
    metaDescription: "Behöver taket skottas eller istappar tas bort? TISAB hjälper BRF och fastighetsägare i Stockholm med takskottning och vinteravtal. Kontakta oss om behovet.",
    h1: "Takskottning och istappsborttagning",
    intro: "Takskottning och istappsborttagning skyddar taket och de som rör sig vid fastigheten under vintern. TISAB erbjuder skonsam takskottning med avropsavtal eller bevakat vinteravtal – främst för BRF, företag och fastighetsägare.",
    who: "BRF, företag och fastighetsägare som behöver bevakad snö- och ishantering under vintern.",
    commonProblems: [
      "Snö och is som belastar taket",
      "Istappar som utgör risk",
      "Behov av bevakat vinteravtal",
    ],
    whatWeDo: ["Inledande bedömning", "Skonsam takskottning", "Hantering av istappar", "Bevakat vinteravtal eller avropsavtal"],
    includes: ["Avropsavtal", "Bevakat vinteravtal", "Skonsam takskottning", "Hantering av istappar", "Inledande bedömning"],
    process: ["Bedömning", "Val av upplägg", "Bevakning", "Åtgärd vid behov"],
    priceFactors: ["Upplägg (avrop eller bevakat)", "Takets storlek", "Säsong"],
    relatedMaterials: [],
    relatedServices: ["serviceavtal", "takservice"],
    relatedGuides: ["takskottning-ansvar-sno-och-is", "underhall-av-tak-aret-runt"],
    faq: [
      { q: "Har ni jour dygnet runt?", a: "Vi erbjuder avropsavtal och bevakat vinteravtal. Kontakta oss om tillgänglighet, bevakning och villkor för din fastighet." },
      { q: "Vem ansvarar för takskottning?", a: "Ansvaret varierar med fastighetstyp och avtal. Se vår guide om takskottning, ansvar, snö och is." },
    ],
    image: IMAGES.brfAerial,
    schemaType: "Service",
  },
  {
    slug: "takentreprenad",
    path: "/takentreprenad/",
    title: "Takentreprenad för BRF & Företag i Stockholm – TISAB",
    metaDescription: "Takentreprenad i Stockholm för BRF och företag. TISAB hanterar förstudie, planering, genomförande, dokumentation och uppföljning. Begär underlag och offert.",
    h1: "Takentreprenad för BRF och företag",
    intro: "Takentreprenad för BRF och företag kräver ett tydligt underlag, en trygg genomförandeplan och dokumenterad uppföljning. TISAB hanterar hela kedjan – från förstudie och beslutsunderlag till genomförande, slutkontroll och serviceavtal.",
    who: "Styrelser, förvaltare, fastighetsägare och hyresvärdar med flerbostadshus och större fastigheter.",
    commonProblems: [
      "Behov av beslutsunderlag för styrelse",
      "Komplexa tak med flera byggnader",
      "Krav på dokumentation och boendekommunikation",
      "Behov av samordnad planering och etapper",
    ],
    whatWeDo: ["Behovsanalys och förstudie", "Omfattningsunderlag", "Planering och projektering", "Genomförande och etapper", "Löpande kommunikation och boendeinformation", "Dokumentation, kontroll och överlämning", "Uppföljning och serviceavtal"],
    includes: ["Behovsanalys", "Förstudie", "Omfattningsunderlag", "Planering", "Projektering", "Genomförande", "Löpande kommunikation", "Dokumentation", "Kontroll", "Överlämning", "Uppföljning"],
    process: ["Förstudie", "Beslutsunderlag", "Planering & projektering", "Genomförande", "Slutkontroll", "Uppföljning"],
    priceFactors: ["Omfattning", "Antal byggnader", "Etapper", "Dokumentationskrav", "Åtkomst"],
    relatedMaterials: ["plattak", "papptak", "tegeltak"],
    relatedServices: ["serviceavtal", "takbesiktning", "snoskottning", "platslageri"],
    relatedGuides: ["takrenovering-for-brf", "underhall-av-tak-aret-runt", "vad-kostar-ett-takbyte"],
    faq: [
      { q: "Vad ingår i en takentreprenad?", a: "Förstudie, beslutsunderlag, planering, projektering, genomförande, löpande kommunikation, dokumentation, kontroll, överlämning och uppföljning." },
      { q: "Kan ni hantera etapper och boendekommunikation?", a: "Ja, vi planerar genomförandet i etapper och kommunicerar med boende och förvaltning under projektet." },
    ],
    image: IMAGES.brfAerial,
    schemaType: "Service",
  },
  {
    slug: "pris-pa-tak",
    path: "/pris-pa-tak/",
    title: "Takbyte pris – vad kostar det att byta tak? | TISAB",
    metaDescription: "Vad kostar ett takbyte? Se vad material, takyta och underarbete betyder för priset. Jämför vad som ingår och begär kostnadsfri offert för ditt tak.",
    h1: "Pris på tak – vad påverkar kostnaden",
    intro: "Takyta, material, takets form och underlagets skick påverkar priset. Beskriv ditt tak i offertunderlaget så kan TISAB bedöma omfattningen och nästa steg. Jämför även vad som ingår i olika offerter, hur tillägg hanteras och vilka villkor som gäller.",
    who: "Privatkunder, BRF och företag som vill förstå vad ett takprojekt kan kosta innan de begär offert.",
    commonProblems: [
      "Oklart vad ett takbyte eller en renovering kostar",
      "Svårt att jämföra offerter utan att förstå prisdrivare",
      "Behov av ett underlag inför budgetering",
    ],
    whatWeDo: ["Förklarar alla prisdrivare", "Ger ett offertunderlag", "Hjälper dig bedöma nästa steg"],
    includes: ["Se prisdrivare nedan", "Offertunderlag", "Beslutsstöd"],
    process: ["Fyll i offertunderlag", "Vi bedömer", "Offert"],
    priceFactors: ["Takyta", "Takets form", "Lutning", "Nuvarande material", "Nytt material", "Underarbete", "Råspont och underlag", "Ställning och logistik", "Genomföringar", "Kupor", "Skorstenar", "Plåtdetaljer", "Avvattning", "Taksäkerhet", "Åtkomst", "Eventuella skador"],
    relatedMaterials: ["plattak", "papptak", "tegeltak", "takmaterial/betongpannor"],
    relatedServices: ["byta-tak", "delbetalning", "takbesiktning"],
    relatedGuides: ["vad-kostar-ett-takbyte", "valja-takmaterial"],
    faq: [
      { q: "Hur får jag pris på mitt tak?", a: "Börja med att beskriva taket, fastighetens plats och vad du vill åtgärda. TISAB går igenom underlaget och bedömer om ett platsbesök behövs innan en offert kan lämnas." },
      { q: "Kan jag få ROT-avdrag?", a: "Du kan ha rätt till ROT-avdrag för en del av arbetskostnaden. Material och resor ger inte rätt till avdrag. Kontrollera aktuella regler hos Skatteverket." },
    ],
    image: IMAGES.villaMetal,
    schemaType: "Service",
  },
  {
    slug: "delbetalning",
    path: "/delbetalning/",
    title: "Delbetalning av takbyte – frågor & villkor | TISAB",
    metaDescription: "Vill du diskutera delbetalning av takbytet? Kontakta TISAB om aktuella möjligheter och villkor för ditt projekt. Börja med ett tydligt offertunderlag.",
    h1: "Delbetalning och finansiering av tak",
    intro: "Börja med en offert som visar takprojektets omfattning och kostnad. Har du frågor om delbetalning kan du kontakta TISAB om aktuella möjligheter för ditt projekt. Ränta, avgifter, löptid och övriga villkor behöver framgå innan du tar ställning.",
    who: "Privatkunder som vill sprida kostnaden för ett takbyte eller en takrenovering.",
    commonProblems: ["Behov av att sprida kostnaden", "Oklart hur ROT-avdrag fungerar"],
    whatWeDo: ["Information om ROT-avdrag", "Genomgång av aktuella möjligheter till delbetalning", "Offert som underlag"],
    includes: ["ROT-information", "Frågor om aktuella finansieringsvillkor"],
    process: ["Offert", "Information om avdrag och finansiering", "Genomförande"],
    priceFactors: ["Projektets omfattning", "ROT-avdrag", "Finansieringsvillkor"],
    relatedMaterials: [],
    relatedServices: ["byta-tak", "pris-pa-tak"],
    relatedGuides: ["vad-kostar-ett-takbyte"],
    faq: [
      { q: "Vilken ränta och löptid gäller?", a: "Kontakta TISAB om aktuella möjligheter för ditt projekt. Be om skriftlig information om ränta, avgifter, total kostnad och löptid innan du tar ställning till delbetalning." },
      { q: "Vem är finansieringspartner?", a: "Kontakta TISAB för aktuellt besked om finansieringspartner och vilka alternativ som är tillgängliga för ditt projekt." },
    ],
    image: IMAGES.villaMetal,
    schemaType: "Service",
  },
  {
    slug: "takmaterial",
    path: "/takmaterial/",
    title: "Takmaterial – jämför tegel, betong, plåt & papp | TISAB",
    metaDescription: "Vilket takmaterial passar ditt hus? Jämför tegel, betongpannor, plåt och takpapp utifrån takets lutning, konstruktion och underhåll. Få hjälp av TISAB.",
    h1: "Takmaterial – välj rätt material för ditt tak",
    intro: "Valet av takmaterial påverkar utseende, livslängd och pris. TISAB arbetar med lertegel, betongpannor, ytpapp, papptak, plåt och bandtäckning – och ger materialrådgivning som en del av bedömningen och offerten.",
    who: "Fastighetsägare som står inför materialval vid takbyte eller renovering.",
    commonProblems: ["Oklart vilket material som passar taket", "Behov av jämförelse mellan material", "Konstruktion och lutning styr valet"],
    whatWeDo: ["Materialrådgivning", "Bedömning av konstruktion och lutning", "Jämförelse av material"],
    includes: ["Lertegel", "Betongpannor", "Ytpapp", "Papptak", "Plåt", "Bandtäckning"],
    process: ["Bedömning", "Materialrådgivning", "Offert"],
    priceFactors: ["Material", "Takyta", "Lutning", "Underarbete"],
    relatedMaterials: ["plattak", "papptak", "tegeltak", "takmaterial/betongpannor"],
    relatedServices: ["byta-tak", "taklaggare"],
    relatedGuides: ["valja-takmaterial"],
    faq: [
      { q: "Hur väljer jag takmaterial?", a: "Det beror på takets konstruktion, lutning, utseende och budget. Vi ger materialrådgivning som en del av offertprocessen." },
      { q: "Vilka material arbetar ni med?", a: "Lertegel, betongpannor, ytpapp, papptak, plåt och bandtäckning – nästan uteslutande erkända svenska märken." },
    ],
    image: IMAGES.tileDetail,
    schemaType: "Service",
  },
  {
    slug: "tegeltak",
    path: "/takmaterial/lertegel/",
    title: "Tegeltak & lertegel – lägga eller byta tak | TISAB",
    metaDescription: "Planerar du tegeltak? Läs om lertegel, underlag och plåtdetaljer. TISAB hjälper med läggning och omläggning i Stockholm. Begär offert för villa eller BRF.",
    h1: "Tegeltak och lertegel",
    intro: "Tegeltak av lertegel ger en klassisk och hållbar yta. TISAB bedömer takets konstruktion, gör nödvändigt underarbete och lägger eller omlägger tegel med anslutande plåtdetaljer från egen plåtverkstad.",
    who: "Fastighetsägare med befintliga tegeltak eller de som önskar lertegel vid takbyte.",
    commonProblems: ["Spruckna eller skadade tegelpannor", "Sliten underpapp under teglet", "Behov av omläggning"],
    whatWeDo: ["Bedömning av konstruktion", "Underarbete", "Materialrådgivning", "Läggning och omläggning", "Anslutande plåtdetaljer"],
    includes: ["Bedömning av konstruktion", "Underarbete", "Materialrådgivning", "Läggning", "Omläggning", "Anslutande plåtdetaljer"],
    process: ["Bedömning", "Underarbete", "Läggning", "Slutkontroll"],
    priceFactors: ["Takyta", "Lutning", "Underarbete", "Antal pannor", "Plåtdetaljer"],
    relatedMaterials: ["takmaterial/betongpannor", "takmaterial"],
    relatedServices: ["byta-tak", "takservice", "platslageri"],
    relatedGuides: ["valja-takmaterial", "nar-ar-det-dags-att-byta-tak"],
    faq: [
      { q: "Vad är skillnaden mellan lertegel och betongpannor?", a: "Lertegel är bränd lera med klassiskt utseende; betongpannor är gjutna med färg i massan. Läs vår guide om att välja takmaterial." },
      { q: "Kan ett tegeltak renoveras?", a: "Ja, vid omläggning byter vi underpapp och skadade pannor medan tegel i gott skick kan återanvändas." },
    ],
    image: IMAGES.tileDetail,
    schemaType: "Service",
  },
  {
    slug: "takmaterial/betongpannor",
    path: "/takmaterial/betongpannor/",
    title: "Betongpannor – nytt tak & omläggning | TISAB",
    metaDescription: "Är betongpannor rätt för ditt tak? Läs om material, underarbete och detaljer. TISAB lägger och byter betongtak i Stockholm. Begär kostnadsfri offert.",
    h1: "Betongpannor för tak",
    intro: "Betongpannor är en hållbar och prisvärd takpanna med färg i massan. TISAB bedömer takets konstruktion, gör underarbete och lägger eller omlägger betongpannor med anslutande plåtdetaljer.",
    who: "Fastighetsägare som vill ha en hållbar panna till ett konkurrenskraftigt pris.",
    commonProblems: ["Skadade eller slitna betongpannor", "Sliten underpapp", "Behov av omläggning"],
    whatWeDo: ["Bedömning av konstruktion", "Underarbete", "Materialrådgivning", "Läggning och omläggning", "Anslutande plåtdetaljer"],
    includes: ["Bedömning", "Underarbete", "Materialrådgivning", "Läggning", "Omläggning", "Plåtdetaljer"],
    process: ["Bedömning", "Underarbete", "Läggning", "Slutkontroll"],
    priceFactors: ["Takyta", "Lutning", "Underarbete", "Antal pannor", "Plåtdetaljer"],
    relatedMaterials: ["tegeltak", "takmaterial"],
    relatedServices: ["byta-tak", "takservice"],
    relatedGuides: ["valja-takmaterial"],
    faq: [
      { q: "Hur lång livslängd har betongpannor?", a: "Livslängden beror på pannornas kvalitet, läge och underhåll. Även underlag, läkt och anslutningar påverkar när taket behöver åtgärdas. En kontroll ger underlag för att bedöma ditt tak." },
      { q: "Kan jag blanda betongpannor och lertegel?", a: "Det beror på konstruktion och utseende. Vi ger materialrådgivning utifrån ditt tak." },
    ],
    image: IMAGES.tileDetail,
    schemaType: "Service",
  },
  {
    slug: "papptak",
    path: "/takmaterial/takpapp/",
    title: "Papptak & takpapp – läggning och renovering | TISAB",
    metaDescription: "Behöver papptaket läggas om? TISAB hjälper med takpapp och tätskikt anpassat till takets lutning och konstruktion. Läs om arbetet och begär offert.",
    h1: "Papptak och takpapp",
    intro: "Papptak är en vanlig lösning för platta och svagt lutande tak. TISAB bedömer taket, lägger nytt papptak, omlägger eller renoverar med en tätskiktslösning anpassad till konstruktion och lutning.",
    who: "Fastighetsägare med platta eller svagt lutande tak – villa, BRF och företag.",
    commonProblems: ["Sliten eller blåst takpapp", "Läckage på platta tak", "Behov av nytt tätskikt"],
    whatWeDo: ["Bedömning", "Nytt papptak", "Omläggning", "Renovering", "Tätning", "Tätskiktslösning anpassad till lutning"],
    includes: ["Bedömning", "Nytt papptak", "Omläggning", "Renovering", "Tätning", "Tätskiktslösning"],
    process: ["Bedömning", "Demontering", "Läggning", "Slutkontroll"],
    priceFactors: ["Takyta", "Lutning", "Antal skikt", "Underarbete", "Genomföringar"],
    relatedMaterials: ["takmaterial", "plattak"],
    relatedServices: ["byta-tak", "takservice"],
    relatedGuides: ["underhall-av-tak-aret-runt", "tecken-pa-takskador", "valja-takmaterial"],
    faq: [
      { q: "Passar papptak på alla tak?", a: "Papptak passar platta och svagt lutande tak. Vid brantare lutning kan andra material vara lämpligare – vi bedömer detta." },
      { q: "Kan ett papptak renoveras?", a: "Ja, vid mindre skador kan tätning eller partiell omläggning räcka. Vid omfattande slitage rekommenderas omläggning eller byte." },
    ],
    image: IMAGES.metalDetail,
    schemaType: "Service",
  },
  {
    slug: "plattak",
    path: "/takmaterial/plat/",
    title: "Plåttak – falsad plåt & bandtäckning | TISAB",
    metaDescription: "Välja plåttak eller renovera det du har? TISAB arbetar med falsad plåt, bandtäckning och profilplåt och har egen plåtverkstad. Läs mer och begär offert.",
    h1: "Plåttak – falsad plåt, bandtäckning och profilplåt",
    intro: "Plåttak är ett av de vanligaste takmaterialen i Sverige. TISAB lägger falsad plåt, bandtäckning och profilplåt – med egen plåtverkstad för måttanpassade detaljer. Takets skick och konstruktion avgör vilket plåtsystem, underarbete och underhåll som passar.",
    who: "Privatkunder, BRF och företag som har eller överväger plåttak – och som vill förstå val, underhåll och pris.",
    commonProblems: ["Rost på äldre plåttak", "Flagnande färg", "Läckage vid fals eller anslutningar", "Behov av omläggning"],
    whatWeDo: ["Bedömning", "Takläggning eller omläggning av plåt", "Falsad plåt", "Bandtäckning", "Måttanpassade detaljer från egen plåtverkstad", "Reparation och målning"],
    includes: ["Falsad plåt", "Bandtäckning", "Profilplåt", "Underarbete", "Måttanpassade detaljer", "Beslag och anslutningar", "Reparation", "Målning"],
    process: ["Bedömning", "Val av plåtsystem", "Underarbete", "Tillverkning av detaljer", "Montering", "Slutkontroll"],
    priceFactors: ["Takyta", "Plåtsystem", "Underarbete", "Detaljer och beslag", "Åtkomst", "Eventuell målning"],
    relatedMaterials: ["takmaterial", "tegeltak", "papptak"],
    relatedServices: ["takmalning", "platslageri", "byta-tak", "takservice"],
    relatedGuides: ["valja-takmaterial", "underhall-av-tak-aret-runt"],
    faq: [
      { q: "Vad är falsad plåt?", a: "Falsad plåt är plåtkvaliteter som fogas genom att plåten viks (falsas) längs sömmarna. Det ger en tät och snygg yta utan genomgående skruv." },
      { q: "Vad är bandtäckning?", a: "Bandtäckning innebär att plåten läggs i långa banor som täcks i fals längs sidorna – vanligt på tak med viss lutning." },
      { q: "Kan ni tillverka egna detaljer?", a: "Ja, TISAB har en egen plåtverkstad där vi tillverkar måttanpassade takplåtar, beslag och genomföringar." },
      { q: "När ska plåttaket målas i stället för bytas?", a: "Om plåten är i gott skick men färgen är rostig eller flagig kan målning räcka. Vid tunt eller skadat material kan reparation eller byte behövas." },
    ],
    image: IMAGES.metalDetail,
    schemaType: "Service",
    isHub: true,
  },
];

const PUBLISHED_SERVICE_SLUGS = [
  "taklaggare",
  "byta-tak",
  "takbesiktning",
  "takservice",
  "takmalning",
  "platslageri",
  "serviceavtal",
  "snoskottning",
  "pris-pa-tak",
  "delbetalning",
  "takmaterial",
  "tegeltak",
  "takmaterial/betongpannor",
  "papptak",
  "plattak",
];

export const SERVICES = ALL_SERVICES.filter((service) =>
  PUBLISHED_SERVICE_SLUGS.includes(service.slug)
);

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
